import { EntityCardSize, ModuleSection } from '@/components';
import ReportCard from '@/components/report/ReportCard';
import ReportModulHeader from '@/components/report/ReportModulHeader';
import { ModuleBaseModel, ReportSearchModel, ModuleSectionPropsModel } from '@/types';
import classNames from 'classnames';

type ReportCarouselModuleModel = ModuleBaseModel<
  {
    carouselIsForParent: boolean;
    collapseMoreInSeries: boolean;
    cards: ReportSearchModel[];
  } & ModuleSectionPropsModel
>;

const ReportCarouselModule = (data: ReportCarouselModuleModel) => {
  const { props } = data;

  return (
    <ModuleSection
      data={{ ...data, props: { ...props, heading: '', backgroundColour: '#F2F2F2' } }}
      className="overflow-hidden"
    >
      <ReportModulHeader
        className="container"
        title={data.props.heading}
        expanded={!data.props.collapseMoreInSeries}
        saveOpenStateKey="reportCarouselModule"
      >
        <div className="-mx-1 flex flex-wrap pt-10 pb-1 sm:pt-13 md:-mx-3 lg:pt-14">
          {props.cards &&
            props.cards.length > 0 &&
            props.cards.map((report, index) => (
              <div
                key={report.reportId}
                className={classNames(
                  props.carouselIsForParent
                    ? 'w-1/2 sm:w-4/12 lg:w-3/12'
                    : index === 0
                      ? 'w-full sm:w-3/12 lg:w-2/12'
                      : 'w-1/2 sm:w-3/12 lg:w-2/12',
                )}
              >
                <div
                  className={classNames(
                    'm-1 border-2 md:m-3',
                    !props.carouselIsForParent && report.isActive ? 'border-black' : 'border-transparent',
                  )}
                >
                  <ReportCard className="p-px" data={report} size={EntityCardSize.AUTO} hideTopContent />
                </div>
              </div>
            ))}
        </div>
      </ReportModulHeader>
    </ModuleSection>
  );
};

export default ReportCarouselModule;
